import { piniaGlobal, Vue, vuetify } from 'src/configs'
import parseJson from 'src/functions/parseJson'
import { useContextStore } from 'src/store'
import initI18next from 'src/utils/initI18next'
import getUserLanguage from 'src/utils/getUserLanguage'

export default async function initLpuLoyaltyProgram() {
  const elements = document.querySelectorAll('.vue-lpu-loyalty-program-mount')

  if (!elements.length) {
    return
  }

  const { default: component } = await import(/* webpackMode: 'eager' */ 'src/components/common/LpuLoyaltyProgram/LpuLoyaltyProgram.vue')

  const contextStore = useContextStore(piniaGlobal)

  if (!('flavour' in contextStore.context) || !('currency' in contextStore.context)) {
    contextStore.$patch(state => {
      Object.assign(state.context, {
        flavour: window.MOBILE_VERSION
          ? 'mobile'
          : 'full',
        currency: window.CURRENCY_DATA,
      })
    })
  }

  await initI18next({
    userLanguage: getUserLanguage(piniaGlobal),
  })

  elements.forEach(el => {
    const props = parseJson(el.getAttribute('data-props'))

    new Vue({
      el,
      // @ts-ignore
      // eslint-disable-next-line no-underscore-dangle
      name: component.__name || component.name,
      pinia: piniaGlobal,
      vuetify,
      render: h => h(component, { props }),
    })
  })
}
